import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { fmtDate } from "@/lib/format";

export default function NewsDetail() {
  const { id } = useParams();
  const [a, setA] = useState(undefined);
  useEffect(() => { api.get(`/articles/${id}`).then((r) => setA(r.data)).catch(() => setA(null)); }, [id]);

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 py-14 lg:py-20">
      <Link to="/communiques" data-testid="news-back-link" className="inline-flex items-center gap-1 text-sm font-semibold text-emerald-800 hover:gap-2 transition-[gap]"><ArrowLeft className="h-4 w-4" /> Communiqués</Link>
      {a === undefined && <Loader2 className="mt-10 h-8 w-8 animate-spin text-emerald-700" />}
      {a === null && <p data-testid="news-not-found" className="mt-10 text-slate-500">Ce communiqué est introuvable.</p>}
      {a && (
        <div className="rise mt-8 space-y-6">
          <div className="text-xs uppercase tracking-[0.14em] text-emerald-700 font-semibold">{fmtDate(a.created_at)}</div>
          <h1 data-testid="news-detail-title" className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 leading-tight">{a.titre}</h1>
          {a.image && <img src={fileUrl(a.image)} alt={a.titre} className="w-full rounded-2xl object-cover max-h-[460px]" />}
          <div data-testid="news-detail-content" className="text-slate-700 leading-relaxed whitespace-pre-line">{a.contenu}</div>
        </div>
      )}
    </article>
  );
}
